export enum FilterValues {
  ALL = 'all',
  PRODUCT = 'product',
  RESOURCE = 'resource',
  DISCUSSIONS = 'discussion',
  VIDEO = 'video',
  ARTICLE = 'article',
  RLS = 'rls',
}
